import strappedConnected from "modules/Core/higher-order-components/strappedConnected";
import cells from "modules/auth/state";
import LegalLayout from "../../LegalLayout";

const CONTACT_EMAIL = "morrisgaby987@gmail.com";

const Email = () => <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>;

const SECTIONS = [
    {
        id: "email",
        title: "Email",
        highlight: true,
        content: (
            <>
                <p><Email /></p>
                <p>
                    For any questions about your account, subscription or usage, please reach out by email and we will
                    get back to you as soon as we can.
                </p>
            </>
        ),
    },
    {
        id: "privacy-requests",
        title: "Privacy and data requests",
        content: (
            <p>
                To access, correct or delete your personal information, email <Email />. You can read how we handle your
                data in our <a href="/privacy">Privacy Policy</a>, or see{" "}
                <a href="/delete-account">how to delete your account</a>.
            </p>
        ),
    },
    {
        id: "developer",
        title: "Developer",
        content: (
            <p>
                <strong>Gabriel Morris</strong>
                <br />
                Developer of Transient Spaces
                <br />
                England, United Kingdom
            </p>
        ),
    },
];

const ContactPage = ({ isAuthed }) => (
    <LegalLayout
        isAuthed={isAuthed}
        eyebrow="Support"
        title="Contact us"
        intro={<p>Questions, feedback or requests? We’d love to hear from you.</p>}
        sections={SECTIONS}
    />
);

export default strappedConnected(
    ContactPage,
    { isAuthed: cells.validateToken.selectors.isAuthed },
    {},
    () => ({})
);
